import { render, staticRenderFns } from "./TotalGovContribution.vue?vue&type=template&id=784e7976"
import script from "./TotalGovContribution.vue?vue&type=script&lang=js"
export * from "./TotalGovContribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports